import api from "..";

export const fetchNotifications = (params = {}, callBack) => {
    api.get(`/notification/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const markAllAsReadNotifications = (callBack) => {
    api.post(`/notification/mark_all_as_read/`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const markAsReadSingleNotification = (id, callBack) => {
    api.post(`/notification/${id}/mark_as_read/`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};